@if (dataLoaded) {
  <div id="range-table-container">
    <table class="table table-responsive" id="range-table-tbl-main">
      <caption></caption>
      <thead>
        @if (valueForRangeTable) {
          <tr>
            <th id="range-table-th-range">
              <div style="font-size: 15px;width: max-content;" id="range-table-lbl-month" i18n="@@Range_Month">RANGO / MES</div>
            </th>
            @for (datas of data; track datas; let idx = $index) {
              <th [id]="'range-table-th-period-' + idx">
                <div style="font-size: 15px;width: max-content;">{{datas.periodString}}</div>
              </th>
            }
          </tr>
        }
        @if (valueForRangeTableCL) {
          <tr>
            <th id="range-table-cl-th-range">
              <div style="font-size: 15px;width: max-content;" i18n="@@Range_Month">RANGO / MES</div>
            </th>
            @for (period of valueForRangeTableCL.periods; track period; let idx = $index) {
              <th [id]="'range-table-cl-th-period-' + idx">
                <div style="font-size: 15px;width: max-content;">{{period.period}}</div>
              </th>
            }
          </tr>
        }
      </thead>
      <tbody>
        @if (valueForRangeTable) {
          @for (dataRange of keysRange; track dataRange; let i = $index) {
            <tr [id]="'range-table-row-' + i">
              <td style="font-size: 14px;" [id]="'range-table-cell-label-' + i">{{dataRange}}</td>
              @for (datas of data; track datas; let cont = $index) {
                <td [id]="'range-table-cell-value-' + i + '-' + cont">
                  <div style="font-size: 13px;text-align: center;">
                    {{datas.rangeValues[keysRange[i]]}}
                  </div>
                </td>
              }
            </tr>
          }
        }
        @if (valueForRangeTable) {
          <tr id="range-table-row-totals">
            <td style="font-size: 14px;" id="range-table-cell-totals-label"><strong i18n="@@Totals">Totales</strong></td>
            @for (datapiolita of data; track datapiolita; let cont = $index) {
              <td [id]="'range-table-cell-totals-value-' + cont">
                <div style="font-size: 13px;text-align: center;"><strong>{{datapiolita.totalRegisters}}</strong></div>
              </td>
            }
          </tr>
        }
        @if (valueForRangeTable) {
          <tr id="range-table-row-average">
            <td style="font-size: 14px;" id="range-table-cell-average-label"><strong i18n="@@Average">Promedio</strong></td>
            @for (datapiolita of data; track datapiolita; let cont = $index) {
              <td [id]="'range-table-cell-average-value-' + cont">
                <div style="font-size: 13px;text-align: center;"><strong>{{datapiolita.averageValue.toFixed(2)}}</strong></div>
              </td>
            }
          </tr>
        }
        <!--CHILE-->
        @if (valueForRangeTableCL) {
          @for (dataRange of valueForRangeTableCL.rangeValues; track dataRange; let i = $index) {
            <tr [id]="'range-table-cl-row-' + i">
              <td style="font-size: 14px;" [id]="'range-table-cl-cell-label-' + i">{{dataRange}}</td>
              @for (qty of tableDataCL.get(dataRange); track qty; let cont = $index) {
                <td [id]="'range-table-cl-cell-value-' + i + '-' + cont">
                  <div style="font-size: 13px;text-align: center;">
                    {{qty}}
                  </div>
                </td>
              }
            </tr>
          }
        }
        @if (valueForRangeTableCL) {
          <tr id="range-table-cl-row-totals">
            <td style="font-size: 14px;" id="range-table-cl-cell-totals-label"><strong i18n="@@Totals">Totales</strong></td>
            @for (total of totalsCL; track total; let cont = $index) {
              <td [id]="'range-table-cl-cell-totals-value-' + cont">
                <div style="font-size: 13px;text-align: center;"><strong>{{total}}</strong></div>
              </td>
            }
          </tr>
        }
        @if (valueForRangeTableCL) {
          <tr id="range-table-cl-row-average">
            <td style="font-size: 14px;" id="range-table-cl-cell-average-label"><strong i18n="@@Average">Promedio</strong></td>
            @for (average of averagesCL; track average; let cont = $index) {
              <td [id]="'range-table-cl-cell-average-value-' + cont">
                <div style="font-size: 13px;text-align: center;"><strong>{{average | number:'1.0-2'}}</strong></div>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
}
@if (!dataLoaded) {
  <div id="range-table-container-loader">
    <div style="min-height: 60vh;" class="h-100 w-100 d-flex justify-content-center align-items-center">
      <div class="lds-ring" id="range-table-loader-spinner"><div></div><div></div><div></div></div>
    </div>
  </div>
}


